import React, { useEffect, useState } from 'react';
import api from '../../services/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState({ users: 0, apps: 0, groups: 0 });

  useEffect(() => {
    Promise.all([
      api.get('/users'),
      api.get('/applications/admin/all'),
      api.get('/groups')
    ]).then(([u, a, c]) => {
      setStats({ users: u.data.total || 0, apps: a.data.total || 0, groups: c.data.data?.length || 0 });
    }).catch(console.error);
  }, []);

  const cards = [
    { label: 'Utilisateurs', value: stats.users, icon: '👥', color: '#0F56E3' },
    { label: 'Applications', value: stats.apps, icon: '🔷', color: '#E46138' },
    { label: 'Groupes', value: stats.groups, icon: '📁', color: '#019EF7' },
  ];

  return (
    <div>
      <h2 style={styles.title}>Tableau de bord</h2>
      <div style={styles.grid}>
        {cards.map(card => (
          <div key={card.label} style={styles.card}>
            <div style={{ ...styles.iconBox, background: card.color }}>
              <span style={{ fontSize: 28 }}>{card.icon}</span>
            </div>
            <div>
              <div style={styles.value}>{card.value}</div>
              <div style={styles.label}>{card.label}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={styles.infoBox}>
        <h3 style={{ marginBottom: 12, color: '#062259' }}>🔌 API REST - Intégrations externes</h3>
        <p style={{ color: '#7F7F7F', marginBottom: 16, fontSize: 14 }}>
          Connectez Notion, Airtable ou Make (Integromat) via l'API REST avec votre clé API.
        </p>
        <div style={styles.codeBlock}>
          <div style={styles.codeLine}><span style={{ color: '#019EF7' }}>GET</span> /api/applications/external <span style={{ color: '#7F7F7F' }}>— Lister les applications</span></div>
          <div style={styles.codeLine}><span style={{ color: '#E46138' }}>POST</span> /api/applications/external <span style={{ color: '#7F7F7F' }}>— Créer une application</span></div>
          <div style={styles.codeLine}><span style={{ color: '#019EF7' }}>PUT</span> /api/applications/external/:id <span style={{ color: '#7F7F7F' }}>— Modifier</span></div>
          <div style={styles.codeLine}><span style={{ color: '#E46138' }}>DELETE</span> /api/applications/external/:id <span style={{ color: '#7F7F7F' }}>— Supprimer</span></div>
          <div style={styles.codeLine}><span style={{ color: '#E46138' }}>POST</span> /api/applications/external/:id/grant <span style={{ color: '#7F7F7F' }}>— Donner accès</span></div>
          <div style={styles.codeLine}><span style={{ color: '#7F7F7F' }}>Header requis :</span> <span style={{ color: '#fff' }}>X-API-Key: [votre clé]</span></div>
        </div>
        <a href="/api/docs" target="_blank" rel="noopener noreferrer" style={styles.docsLink}>
          📚 Voir la documentation Swagger complète →
        </a>
      </div>
    </div>
  );
}

const styles = {
  title: { fontSize: 24, fontWeight: 700, color: '#062259', marginBottom: 24 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 32 },
  card: { background: '#fff', borderRadius: 12, padding: 24, display: 'flex', alignItems: 'center', gap: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  iconBox: { width: 56, height: 56, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  value: { fontSize: 32, fontWeight: 700, color: '#062259' },
  label: { fontSize: 14, color: '#7F7F7F' },
  infoBox: { background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  codeBlock: { background: '#062259', borderRadius: 8, padding: '16px 20px', marginBottom: 16, display: 'flex', flexDirection: 'column', gap: 8 },
  codeLine: { fontFamily: 'monospace', fontSize: 13, color: '#fff' },
  docsLink: { color: '#0F56E3', fontSize: 14, fontWeight: 500 },
};
